// extracted by mini-css-extract-plugin
export default {"kanaDetails":"KanaCollectionErrorDetails_kanaDetails__Z-lc2"};